import { Injectable } from '@angular/core';
import { Dexie } from 'dexie';

@Injectable({
  providedIn: 'root'
})
export class IndexDbService extends Dexie {

  constructor () {
    super('unified-platform');
  }

  public init() {
    this.version(1).stores({
      liveQuery: 'id, query, status'
    });
  }

  public getCanonicalComparableSchema(db: Dexie): string {
    return JSON.stringify(
      db.tables
        .map(({ name, schema }) => ({
          name,
          schema: [schema.primKey.src, ...schema.indexes.map(idx => idx.src).sort()].join(
            ','
          ),
        }))
        .sort((a, b) => (a.name < b.name ? 1 : -1))
    );
  }

  public isDeclaredSchemaSameAsInstalled(db: Dexie) {
    const declaredSchema = this.getCanonicalComparableSchema(db);
    return new Dexie(db.name).open().then(dynDb => {
      const installedSchema = this.getCanonicalComparableSchema(dynDb);
      return declaredSchema === installedSchema;
    });
  }

  // public async changeSchema(db: Dexie, schemaChanges: any) {
  //   db.close();
  //   const newDb = new Dexie(db.name);

  //   newDb.on('blocked', () => false); // Silence console warning of blocked event.
  //   // Workaround: If DB is empty from tables, it needs to be recreated
  //   if (db.tables.length === 0) {
  //     await db.delete();
  //     newDb.version(1).stores(schemaChanges);
  //     return await newDb.open();
  //   }

  //   interface ISchema {
  //     name: string;
  //     schema: TableSchema
  //   }
  //   // Extract current schema in dexie format:
  //   const currentSchema = db.tables.reduce((result, {name, schema}) => {
  //     result [name ] = [
  //       schema.primKey.src,
  //       ...schema.indexes.map((idx) => idx.src)
  //     ].join(',')
  //     return result;
  //   }, {});

  //   console.log('Version: ' + db.verno);
  //   console.log('Current Schema: ', currentSchema);

  //   // Tell Dexie about current schema:
  //   newDb.version(db.verno).stores(currentSchema);
  //   // Tell Dexie about next schema:
  //   newDb.version(db.verno + 1).stores(schemaChanges: any);
  //   // Upgrade it:
  //   return await newDb.open();
  // }

  // async function playAround() {
  //   let db = new Dexie('FriendsDatabase2');
  //   if (!await Dexie.exists(db.name)) {
  //     console.log('Db does not exist');
  //     db.version(1).stores({});
  //   }
  //   await db.open();
  //   console.log('Could open DB');

  //   // Add a table with some indexes:
  //   db = await changeSchema(db, {
  //     friends: 'id, name',
  //   });
  //   console.log('Could enforce friends table with id and name');

  //   // Add another index in the friends table
  //   db = await changeSchema(db, {
  //     friends: 'id, name, age',
  //   });
  //   console.log('Could add the age index');

  //   // Remove the age index again:
  //   db = await changeSchema(db, {
  //     friends: 'id, name',
  //   });
  //   console.log('Could remove age index');

  //   // Remove the friends table
  //   db = await changeSchema(db, {
  //     friends: null,
  //   });

}

export const Database = new IndexDbService();